export default __webpack_public_path__ + "static/media/warningIcon.347a767b.svg";